export const APP_LINK = 'https://flirtify.com';
export const RTA_LINK = 'https://www.rtalabel.org/?content=validate&rating=RTA-5042-1996-1400-1577-RTA';
export const HOW_TO_WORK_LINK = {
    en: 'https://join.flirtify.com/how-to-work-en',
    ru: 'https://join.flirtify.com/how-to-work-ru',
    es: 'https://join.flirtify.com/how-to-work-es'
}

export const ECB_LINK =
    'https://www.ecb.europa.eu/stats/policy_and_exchange_rates/euro_reference_exchange_rates/html/index.en.html';
